import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
    SewAccordion,
    SewAccordionItem,
    SewHeadline,
    SewRichtext,
    SewVideo,
} from '@sew/ui-components-angular/standalone';
import { Observable } from 'rxjs';
import { ReplaceDoubleLinebreakPipe } from '../../../../pipes/replace-linebreak.pipe';
import { WhatsNewService } from './whats-new.service';
import { WhatsNewElement } from './whats-new.types';

@Component({
    selector: 'ecs-whats-new',
    templateUrl: './whats-new.component.html',
    styleUrls: ['./whats-new.component.scss'],
    imports: [
        SewHeadline,
        SewRichtext,
        SewAccordion,
        SewAccordionItem,
        SewVideo,
        AsyncPipe,
        ReplaceDoubleLinebreakPipe,
    ],
})
export class WhatsNewComponent implements OnInit {
    public whatsNewObs?: Observable<WhatsNewElement>;

    public constructor(private whatsNewService: WhatsNewService) {}

    public ngOnInit() {
        this.whatsNewObs = this.whatsNewService.fetchWhatsNewData();
    }

    public getVideoSource(whatsNewElement: WhatsNewElement): string | null {
        const video = whatsNewElement.video;
        if (!video) {
            return null;
        }

        return (
            video.src?.replace('https://www.youtube.com/watch?v=', 'https://www.youtube.com/embed/') || null
        );
    }
}
